import { render, staticRenderFns } from "./today.vue?vue&type=template&id=cbb91576&scoped=true"
import script from "./today.vue?vue&type=script&lang=js"
export * from "./today.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb91576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb91576')) {
      api.createRecord('cbb91576', component.options)
    } else {
      api.reload('cbb91576', component.options)
    }
    module.hot.accept("./today.vue?vue&type=template&id=cbb91576&scoped=true", function () {
      api.rerender('cbb91576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/today.vue"
export default component.exports